import { all, call, put, takeEvery } from "redux-saga/effects";
import { push } from "connected-react-router";
import axios from "axios";
import { appConfig } from "../config";
import keycloak from "../keycloak";

import {
  beginMerchandiseReviewSuccess,
  cancelMerchandiseReviewSuccess,
  clearItemNotes,
  createItemNotesError,
  createItemNotesSuccess,
  fetchConsignerOptionsSuccess,
  fetchDonateMerchandiseItemsSuccess,
  fetchDonateMerchandiseItemsError,
  fetchItemChannelInfoError,
  fetchItemChannelInfoSuccess,
  fetchItemNotesError,
  fetchItemNotesSuccess,
  fetchMerchandiseItemsToReviewSuccess,
  fetchMerchandiseItemSuccess,
  fetchPublishedMerchandiseItemsSuccess,
  fetchUnpublishedMerchandiseItemsSuccess,
  makeMerchandiseItemDecisionSuccess,
  matchMerchandiseItemToProductSuccess,
  publishMerchandiseItemSuccess,
  saveItemChannelInfoError,
  saveItemChannelInfoSuccess,
  saveProductChannelInfoError,
  saveProductChannelInfoSuccess,
  saveProductItemSuccess,
  searchMerchandiseProductsSuccess,
  showMerchandiseDetailsSuccess,
  saveProductItemError,
} from "../actions/Merchandising";

import {
  FETCH_CONSIGNER_OPTIONS,
  FETCH_UNPUBLISHED_MERCHANDISE_ITEMS,
  FETCH_PUBLISHED_MERCHANDISE_ITEMS,
  FETCH_MERCHANDISE_ITEMS_TO_REVIEW,
  BEGIN_MERCHANDISE_REVIEW,
  FETCH_MERCHANDISE_ITEM,
  CANCEL_MERCHANDISE_REVIEW,
  SEARCH_MERCHANDISE_PRODUCTS,
  MATCH_MERCHANDISE_TO_PRODUCT,
  PUBLISH_MERCHANDISE_ITEM,
  MAKE_MERCHANDISE_DECISION,
  SHOW_MERCHANDISE_DETAILS,
  SAVE_PRODUCT_ITEM,
  SAVE_PRODUCT_CHANNEL_INFO,
  SAVE_ITEM_CHANNEL_INFO,
  FETCH_ITEM_CHANNEL_INFO,
  FETCH_ITEM_NOTES,
  CREATE_ITEM_NOTES,
  FETCH_DONATE_MERCHANDISE_ITEMS,
} from "../constants/ActionTypes";

const baseUrl = appConfig.baseApiUrl;

const withHeaders = async (block) => {
  return await keycloak.updateToken(20).then(() =>
    block({
      Authorization: "Bearer " + keycloak.token,
      "Csrf-Token": "nocheck-allow",
      "Content-Type": "application/json",
    })
  );
};

const getConsignerOptions = async (data) => {
  return await withHeaders((headers) => {
    return axios
      .get(baseUrl + "/api/merchandise/consigners", { headers: headers })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

const getUnpublishedMerchandiseItems = async (data) => {
  const params = data.payload;
  return await withHeaders((headers) => {
    return axios
      .get(baseUrl + "/api/merchandise/unpublishedItems", {
        headers: headers,
        params: params,
      })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

const getPublishedMerchandiseItems = async (data) => {
  const params = data.payload;
  return await withHeaders((headers) => {
    return axios
      .get(baseUrl + "/api/merchandise/publishedItems", {
        headers: headers,
        params: params,
      })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

const getDonateMerchandiseItems = async data => {
  const params = data.payload;

  return await withHeaders(headers => {
    return axios
      .get(baseUrl + '/api/merchandise/donateDisposeItems', {
        headers: headers,
        params
      })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error('Bad response from server');
        }
        return response.data;
      });
  });
};

const getMerchandiseItemsToReview = async (data) => {
  const params = data.payload;
  return await withHeaders((headers) => {
    return axios
      .get(baseUrl + "/api/merchandise/itemsToReview", {
        headers: headers,
        params: params,
      })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

const postMerchandiseReview = async (data) => {
  let id = data.payload.id;

  return await withHeaders((headers) => {
    return axios
      .post(
        baseUrl + "/api/merchandise/beginReview/" + id,
        {},
        { headers: headers }
      )
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        console.log("MerchandiseBeginReview Data: ", response.data);
        return response.data;
      });
  });
};

const postMerchandiseCancelReview = async (data) => {
  let id = data.payload;

  return await withHeaders((headers) => {
    return axios
      .post(
        baseUrl + "/api/merchandise/cancelReview/" + id,
        {},
        { headers: headers }
      )
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

const getMerchandiseItem = async (data) => {
  // Get id
  let id = data.payload;

  return await withHeaders((headers) => {
    return axios
      .get(baseUrl + "/api/merchandise/item/" + id, { headers: headers })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        console.log("merchandise item info: ", response.data);
        return response.data;
      });
  });
};

const getSearchMerchandiseProducts = async (data) => {
  const params = data.payload;
  return await withHeaders((headers) => {
    return axios
      .get(baseUrl + "/api/merchandise/products/search", {
        headers: headers,
        params: params,
      })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

const postMatchMerchandiseItemToProduct = async (data) => {
  let { id, productId } = data.payload;
  let url = baseUrl + "/api/merchandise/updateMatch/" + id + "/" + productId;

  return await withHeaders((headers) => {
    return axios.post(url, {}, { headers: headers }).then(function(response) {
      console.log("postMatch response:", response);
      if (response.status >= 400) {
        throw new Error("Bad response from server");
      }
      return response.data;
    });
  });
};

const postPublishMerchandiseItem = async (data) => {
  let { id } = data.payload;

  return await withHeaders((headers) => {
    return axios
      .post(baseUrl + "/api/merchandise/publish/" + id, data.payload, {
        headers: headers,
      })
      .then(function(response) {
        console.log("postPublishItem response:", response);
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

const postMakeMerchandiseDecision = async (data) => {
  let { id } = data.payload;

  console.log("make decision post:", data.payload);
  return await withHeaders((headers) => {
    return axios
      .post(baseUrl + "/api/merchandise/decision/" + id, data.payload, {
        headers: headers,
      })
      .then(function(response) {
        console.log("make decision response:", response);
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

const postSaveProductItem = async (data) => {
  let { id } = data.payload;
  console.log("postSaveProductItem:", data.payload);

  return await withHeaders((headers) => {
    return axios
      .put(baseUrl + "/api/merchandise/productItems/" + id, data.payload, {
        headers: headers,
      })
      .then(function(response) {
        console.log("updateProductItems response:", response);
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

const postSaveProductChannelInfo = async (data) => {
  const { id, channelId, enabled, priceAdjustment, fieldValues } = data.payload;
  const body = { channelId, enabled, priceAdjustment, fieldValues };

  return await withHeaders((headers) => {
    return axios
      .post(baseUrl + `/api/merchandise/channelInfo/product/${id}`, body, {
        headers,
      })
      .then(function(response) {
        console.log("postSaveProductChannelInfo response:", response);
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

const postSaveItemChannelInfo = async (data) => {
  const { id, channelId, enabled, priceAdjustment, fieldValues } = data.payload;
  const body = { channelId, enabled, priceAdjustment, fieldValues };

  return await withHeaders((headers) => {
    return axios
      .post(baseUrl + `/api/merchandise/channelInfo/item/${id}`, body, {
        headers,
      })
      .then(function(response) {
        console.log("postSaveItemChannelInfo response:", response);
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

const fetchItemChannelInfo = async (data) => {
  const itemId = data.payload;

  return await withHeaders((headers) => {
    return axios
      .get(baseUrl + `/api/merchandise/channelInfo/item/${itemId}`, { headers })
      .then(function(response) {
        console.log("fetchItemChannelInfo response: ", response);
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

const fetchItemNotes = async (data) => {
  const itemId = data.payload;

  return await withHeaders((headers) => {
    return axios
      .get(baseUrl + `/api/inventory/itemNotes?itemId=${itemId}`, { headers })
      .then(function(response) {
        console.log("fetchItemNotes response: ", response);
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

const createItemNotes = async (data) => {
  const itemId = data.payload.id;
  const body = { message: data.payload.message };

  return await withHeaders((headers) => {
    return axios
      .post(baseUrl + `/api/inventory/itemNotes?itemId=${itemId}`, body, {
        headers,
      })
      .then(function(response) {
        console.log("createItemNotes response: ", response);
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
};

function* fetchConsignerOptionsRequest(data) {
  try {
    const fetched = yield call(getConsignerOptions, data);
    yield put(fetchConsignerOptionsSuccess(fetched));
  } catch (error) {
    console.error(error);
  }
}

function* fetchUnpublishedMerchandiseItemsRequest(data) {
  try {
    const fetched = yield call(getUnpublishedMerchandiseItems, data);
    yield put(fetchUnpublishedMerchandiseItemsSuccess(fetched));
  } catch (error) {
    console.error(error);
  }
}

function* fetchPublishedMerchandiseItemsRequest(data) {
  try {
    const fetched = yield call(getPublishedMerchandiseItems, data);
    yield put(fetchPublishedMerchandiseItemsSuccess(fetched));
  } catch (error) {
    console.error(error);
  }
}

function* fetchDonateMerchandiseItemsRequest(data) {
  try {
    const fetched = yield call(getDonateMerchandiseItems, data);
    yield put(fetchDonateMerchandiseItemsSuccess(fetched));
  } catch (error) {
    console.error(error);
    yield put(fetchDonateMerchandiseItemsError(error));
  }
}

function* fetchMerchandiseItemsToReviewRequest(data) {
  try {
    const fetched = yield call(getMerchandiseItemsToReview, data);
    yield put(fetchMerchandiseItemsToReviewSuccess(fetched));
  } catch (error) {
    console.error(error);
  }
}

function* fetchMerchandiseItemRequest(data) {
  try {
    const fetched = yield call(getMerchandiseItem, data);
    yield put(fetchMerchandiseItemSuccess(fetched));
  } catch (error) {
    console.error(error);
  }
}

function* postMerchandiseReviewRequest(data) {
  try {
    const fetched = yield call(postMerchandiseReview, data);
    yield put(beginMerchandiseReviewSuccess(fetched));
    yield put(push("/app/merchandising-review/" + fetched.id));
  } catch (error) {
    console.error(error);
  }
}

function* postMerchandiseCancelReviewRequest(data) {
  try {
    const fetched = yield call(postMerchandiseCancelReview, data);
    yield put(cancelMerchandiseReviewSuccess(fetched));
    yield put(push("/app/merchandising-list"));
  } catch (error) {
    console.error(error);
  }
}

function* getSearchMerchandiseProductsRequest(data) {
  try {
    const fetched = yield call(getSearchMerchandiseProducts, data);
    yield put(searchMerchandiseProductsSuccess(fetched));
  } catch (error) {
    console.error(error);
  }
}

function* postMatchMerchandiseItemToProductRequest(data) {
  try {
    const fetched = yield call(postMatchMerchandiseItemToProduct, data);
    yield put(matchMerchandiseItemToProductSuccess(fetched));
  } catch (error) {
    console.error(error);
  }
}

function* postPublishMerchandiseItemRequest(data) {
  try {
    const fetched = yield call(postPublishMerchandiseItem, data);
    yield put(publishMerchandiseItemSuccess(fetched));
    yield put(push("/app/merchandising-list"));
  } catch (error) {
    console.error(error);
  }
}

function* postMakeMerchandiseDecisionRequest(data) {
  try {
    const fetched = yield call(postMakeMerchandiseDecision, data);
    yield put(makeMerchandiseItemDecisionSuccess(fetched));
    const redirectTo = data.payload.redirectTo || "/app/merchandising-list";
    yield put(push(redirectTo));
  } catch (error) {
    console.error(error);
  }
}

function* postShowMerchandiseDetailsRequest(data) {
  try {
    const fetched = yield call(getMerchandiseItem, data);
    yield put(showMerchandiseDetailsSuccess(fetched));
    yield put(push("/app/merchandising/" + fetched.id));
  } catch (error) {
    console.error(error);
  }
}

function* postSaveProductItemRequest(data) {
  try {
    const fetched = yield call(postSaveProductItem, data);
    yield put(saveProductItemSuccess(fetched));
    const redirectTo = data.payload.redirectTo || '/app/merchandising-list-published';
    yield put(push(redirectTo));
  } catch (error) {
    console.error(error);
    yield put(saveProductItemError(error));
  }
}

function* postSaveProductChannelInfoRequest(data) {
  try {
    const saveDetails = yield call(postSaveProductChannelInfo, data);
    yield put(saveProductChannelInfoSuccess(saveDetails));
  } catch (error) {
    console.error(error);
    yield put(saveProductChannelInfoError(error));
  }
}

function* postSaveItemChannelInfoRequest(data) {
  try {
    const saveDetails = yield call(postSaveItemChannelInfo, data);
    yield put(saveItemChannelInfoSuccess(saveDetails));
  } catch (error) {
    console.error(error);
    yield put(saveItemChannelInfoError(error));
  }
}

function* fetchItemChannelInfoRequest(data) {
  try {
    const fetchDetails = yield call(fetchItemChannelInfo, data);
    yield put(fetchItemChannelInfoSuccess(fetchDetails));
  } catch (error) {
    console.error(error);
    yield put(fetchItemChannelInfoError(error));
  }
}

function* fetchItemNotesRequest(data) {
  try {
    yield put(clearItemNotes());
    const fetchDetails = yield call(fetchItemNotes, data);
    yield put(fetchItemNotesSuccess(fetchDetails));
  } catch (error) {
    console.error(error);
    yield put(fetchItemNotesError(error));
  }
}

function* createItemNotesRequest(data) {
  try {
    yield call(createItemNotes, data);
    yield put(clearItemNotes());
    const fetchDetails = yield call(fetchItemNotes, {
      payload: data.payload.id,
    });
    yield put(fetchItemNotesSuccess(fetchDetails));
    yield put(createItemNotesSuccess());
  } catch (error) {
    console.error(error);
    yield put(fetchItemNotesError(error));
    yield put(createItemNotesError(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(FETCH_CONSIGNER_OPTIONS, fetchConsignerOptionsRequest),
    takeEvery(
      FETCH_UNPUBLISHED_MERCHANDISE_ITEMS,
      fetchUnpublishedMerchandiseItemsRequest
    ),
    takeEvery(
      FETCH_PUBLISHED_MERCHANDISE_ITEMS,
      fetchPublishedMerchandiseItemsRequest
    ),
    takeEvery(
      FETCH_DONATE_MERCHANDISE_ITEMS,
      fetchDonateMerchandiseItemsRequest
    ),
    takeEvery(
      FETCH_MERCHANDISE_ITEMS_TO_REVIEW,
      fetchMerchandiseItemsToReviewRequest
    ),
    takeEvery(FETCH_MERCHANDISE_ITEM, fetchMerchandiseItemRequest),
    takeEvery(BEGIN_MERCHANDISE_REVIEW, postMerchandiseReviewRequest),
    takeEvery(CANCEL_MERCHANDISE_REVIEW, postMerchandiseCancelReviewRequest),
    takeEvery(SEARCH_MERCHANDISE_PRODUCTS, getSearchMerchandiseProductsRequest),
    takeEvery(
      MATCH_MERCHANDISE_TO_PRODUCT,
      postMatchMerchandiseItemToProductRequest
    ),
    takeEvery(PUBLISH_MERCHANDISE_ITEM, postPublishMerchandiseItemRequest),
    takeEvery(MAKE_MERCHANDISE_DECISION, postMakeMerchandiseDecisionRequest),
    takeEvery(SHOW_MERCHANDISE_DETAILS, postShowMerchandiseDetailsRequest),
    takeEvery(SAVE_PRODUCT_ITEM, postSaveProductItemRequest),
    takeEvery(SAVE_PRODUCT_CHANNEL_INFO, postSaveProductChannelInfoRequest),
    takeEvery(SAVE_ITEM_CHANNEL_INFO, postSaveItemChannelInfoRequest),
    takeEvery(FETCH_ITEM_CHANNEL_INFO, fetchItemChannelInfoRequest),
    takeEvery(FETCH_ITEM_NOTES, fetchItemNotesRequest),
    takeEvery(CREATE_ITEM_NOTES, createItemNotesRequest),
  ]);
}
